<template>
  <div
    class="dropdown-notification mr-25 notificationDisabled"
    role="button"
    tabindex="-1"
    aria-disabled="true"
  >
    <feather-icon
      class="text-body iconLogo"
      icon="BellIcon"
      size="44"
    />
  </div>
</template>

<script>
export default {
}
</script>

<style>
.iconLogo{
  background-color: #52DCAB33;
  border-radius: 10px;
  padding: 0.8rem;
}

.notificationDisabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}
</style>
